import React, { Component } from "react";
import PropTypes from "prop-types";
import { getFirst, getLast, isEmpty, isExist } from "cxa-utils";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import HDFLink from "./HDFLink";

/**
 * BenefitTable component
 * @return {jsx}
 */
const BenefitTable = ({ body, headers }) => (
  <table className="apl-benefit-statement__table">
    <tbody>
      {body.map((field, fIdx) => (
        <tr key={fIdx}>
          <th>{headers[fIdx + 1]}</th>
          <td>{field}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

BenefitTable.propTypes = {
  headers: PropTypes.array,
  body: PropTypes.any,
};

/**
 * BenefitSection component
 * @return {jsx}
 */
const BenefitSection = ({ planYearId, headers, body, completedUwForms, row }) => (
  <section>
    <div className="cxa-grid__wrapper">
      <h5 className="cxa-grid__item cxa-grid__item--six">
        <span>{getFirst(row)}</span>
        <span>{getLast(row)}</span>
      </h5>
      {isExist(completedUwForms) && (
        <ul className="cxa-grid__item cxa-grid__item--six">
          {completedUwForms.map((uw) => (
            <li key={uw.uwFormCode}>
              <HDFLink
                key={uw.uwFormCode}
                planYearId={planYearId}
                uwFormCode={uw.uwFormCode}
                enrolmentKey={uw.enrolmentKey}
                completedOn={uw.completedOn}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
    <BenefitTable headers={headers} body={body} />
  </section>
);

BenefitSection.propTypes = {
  planYearId: PropTypes.string,
  headers: PropTypes.array,
  body: PropTypes.any,
  rows: PropTypes.array,
  completedUwForms: PropTypes.array,
  row: PropTypes.array,
};

/**
 * BenefitsData component
 * @extends React.Component
 */
class BenefitsData extends Component {
  static propTypes = {
    planYearId: PropTypes.string,
    rows: PropTypes.array,
    headers: PropTypes.array,
    benefits: PropTypes.array,
    otherBenefits: PropTypes.array,
  };

  static defaultProps = {
    planYearId: "",
    rows: [],
    headers: [],
    benefits: [],
    otherBenefits: [],
  };

  shouldComponentUpdate(nextProps) {
    const { rows, headers } = nextProps;

    if (isEmpty(rows, headers)) {
      return false;
    }

    return true;
  }

  renderOtherBenfits = () => {
    const { otherBenefits } = this.props;
    if (!otherBenefits || !otherBenefits.length) {
      return null;
    }
    return otherBenefits.map(benefit => {
      return (
        <div key={benefit.benefitId} className="other-benefits">
          <h5>
            <span>{benefit.benefitName}</span>
          </h5>
          <table className="apl-benefit-statement__table">
            <tbody>
              <tr>
                <th>
                  {benefit.isDefault ? (
                    <FormattedMessage {...messages.otherBenefits.defaultPlan} />
                  ) : (
                    <FormattedMessage {...messages.otherBenefits.selectedPlan} />
                  )}
                </th>
                <td>{benefit.selectedPlan}</td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage {...messages.otherBenefits.members} />
                </th>
                <td>{benefit.members.map(member => member.name).join(", ")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    });
  };

  render() {
    const { planYearId, rows, headers, benefits } = this.props;

    return (
      <div>
        {rows
          .map((row, idx) => ({
            body: row.slice(1, -1).filter(x => x),
            // 'benefits' array's index should be same as 'rows' array
            completedUwForms: benefits[idx].completedUwForms,
            row,
          }))
          .map(({ body, completedUwForms, row }, idx) => (
            <BenefitSection
              key={idx}
              planYearId={planYearId}
              headers={headers}
              body={body}
              row={row}
              completedUwForms={completedUwForms}
            />
          ))}
        {this.renderOtherBenfits()}
      </div>
    );
  }
}

export default BenefitsData;



// WEBPACK FOOTER //
// ./components/employee/benefits/BenefitsData.js